import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-lagerort-list-view',
  imports: [],
  templateUrl: './lagerort.list-view.html',
  styleUrls: ['./lagerort.list-view.css'],
})
export class LagerortListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
